<template>
    <portal v-if="mounted" :to="portalTo" :disabled="!isMobile">
        <slot></slot>
    </portal>
    <div v-else style="opacity: 0">
        <slot></slot>
    </div>
</template>

<script>
import { isMobileMixin } from '~/app/mixins/isMobile.mixin';

export default {
    mixins: [
        isMobileMixin
    ],
    props: {
        portalTo: String,
    },
    data() {
        return {
            mounted: false
        };
    },
    mounted(){
        this.mounted = true;
    }
}
</script>
